
// WebpackRequireFrom
typeof __webpack_require__ !== "undefined" && Object.defineProperty(__webpack_require__, "p", {
  get: function () {
try {
  if (typeof __getSweetProcessBundlesPublicPath__ !== "function") {
    throw new Error("WebpackRequireFrom: '__getSweetProcessBundlesPublicPath__' is not a function or not available at runtime. See https://github.com/agoldis/webpack-require-from#troubleshooting");
  }
  return __getSweetProcessBundlesPublicPath__();
} catch (e) {
  if (!false) {
    console.error(e);
  }
  return "auto";
}
 },
  set: function (newPublicPath) {
    console.warn("WebpackRequireFrom: something is trying to override webpack public path. Ignoring the new value" + newPublicPath  + ".");
}
});